import _, { filter, get } from 'lodash';
import PageLoader from '@/common/service/flow/page-loader';
import { buildAccountBaseService } from '@/common/service/base-paid';
import { loadSelectByPersist ,filterCapacity  } from '@/common/service/plan-data-mapper';
import { flowTypes, pageConfig } from '@/common/service/page-config';
import store from '@/store/index';
import {
  addToCartByCategoryAndBillingCycle,
  addToCartByPlanCode,
  addToCartByPlanType,
  de$type,
  isFromCancelCampaignWithPendingCase,
  planQueryParser,
} from '@/common/service/flow/utils';
import {
  planTypes,
  multiCapacityPlans,
  configCapacityTypes,
  MULTI_UPDATE_PLAN_TYPES,
  BIZ_PLUS_PLAN_CODES_ONLINE_SUPPORTED,
  BUNDLE_WITH_ZP_BASE_PLAN_TYPES,
  PBX_CATEGORYS,
  EDU_SCH_CMP_PLUS_PLAN_CODES_SUPPORTED,
  ABANDON_CART_EMAIL_COOKIE_KEY,
  VIEWS,
  BILLING_CYCLE
} from '@/common/constants';
import { preCheckForPbx } from '@/common/service/validate/pbx';
import { getAssignLicenseResult } from '@/common/service/validate/assign-license';
import { logger } from "@/utils/log";
import { preCheckPendingCouponForEdit } from '@/common/service/validate/coupon';
import { checkOneMonthPlanDownSellForEdit, checkPlanDownSellForEdit } from '@/common/service/validate/downsell';
import { getBasePlanInfo } from '@/common/product';
import { updatePlansCheckout, UpdateTypes, setMultipleRatePlanFlag, getProPlusEditForm, getUnsupportBillingCycleCategoryMap, getPlanCodeMap } from '@/common/service/checkout-utils';
import { loadDefaultPlansByPreloadCouponForEdit } from '@/views/config/coupon/helper/preload';
import { filterDisabledPlansWithSubscription } from '@/flows/ADD';
import { $context, $query } from "@/global-install";
import Flow from "@/flows/flow";
import { isFromCampaignLink, showCouponTermsMessage } from '@/views/config/coupon/helper/utils';
import { filterEventPlansForAdd2Cart } from "@/plans/EVENT_SAAS/helper/filter";
import { plansof } from "@/utils/chain";
import { capacityConfig } from '@/apis';
import { isBizPlusContext, isProPlusContext, isEduSchCmpPlusContext, isInUnlockBizCountRetentionFlow, reactiveBizPlanIfCancelled } from '@/plans/ZOOM_MEETING/common/utils';
import { getBundleCategoryPlans, checkBizPlusAddonLicensePromise } from '@/plans/ZOOM_ONE_BUNDLE/utils';
import { getBoughtTollFree, getTollFreeUpdateForm, syncBoughtTollFreeInfo2Cart } from "@/plans/TOLLFREE/helpers/flow";
import {
  isOnlineNotSupportPlan,
  ONLINE_NOT_SUPPORT_BILLING_CYCLE,
} from '@/common/service/non-standard-billing-cycle-utils';
import { checkCountriesRegionsOption } from "@/common/service/validate/tollfree";
import { PBX_SUB_TYPES, computedPbxPlans } from '@/common/service/computers/plans/pbx';
import MessageBox from '@zoom/zoom-ui/src/components/message-box/message-box';
import { translation } from '@/plugins/i18n';
import { freeTrialIneligibleCheck } from '../BUY_TRIAL/index';
import { getPlanTypeByCategory } from '@/common/service/parse';
import offerNotEligible from '@/components/offer-not-eligible';
import { loadDefaultPlansByPartnerReferralForEdit } from '@/views/config/partner-refer/helper/preload';
import { getPartnershipParams } from '@/views/config/partner-refer/helper/params';
import getPbxBillingCycle from '@/plans/ZOOM_PHONE/helper/pbx-billing-cycle';
import {
  getMeeting2BizPlusUpdateForm,
  getPro2ProPlusUpdateForm,
  getProPlus2BizPlusUpdateForm,
  getDowngradeToProPlusForm,
  checkAudioChange,
  getEdu2EduPlusUpdateForm
} from '../utils.js'
import { checkZoneEduPlusAddonLicense } from '@/plans/ZONE_EDU_PLUS/utils';
import { loadDefaultPlansByCartId } from '@/views/config/coupon/helper/preload';
import { verifyAbandonCardForP2P } from '../helper/abandon-cart';
import { couponSourceTypeMap } from '@/views/config/coupon/helper/constant';
import { PBX_REGIONS } from '@/plans/ZOOM_PHONE/helper/constants';

const editType = pageConfig?.editConfig?.planType;

const loadDefaultSelectByQuery = (boughtPlans = []) => {
    return (planList = []) => {

        const hasSelected = planList?.find((p) => p.cartInfo.selected_number > 0);

        if (!hasSelected) {
          if (editType === planTypes.TOLLFREE) {
            getBoughtTollFree(boughtPlans).forEach((plan) => {
              if (plan.plan_type) {
                addToCartByPlanType(planList, plan.plan_type, plan.cartInfo.selected_number)
              } else {
                addToCartByPlanCode(planList, plan.plan_code, plan.cartInfo.selected_number);
              }
              syncBoughtTollFreeInfo2Cart(plan, planList);
            });
            return planList;
          }

          let categoryPlans = boughtPlans.filter(x => de$type(x.type) === editType);
          if (multiCapacityPlans.includes(editType)) { // filter plans of capacity that the user is editing
             categoryPlans = categoryPlans.filter(x => x.category === pageConfig?.subPlan)
          }
          // bundle plans (pro+ and biz+)
          if (BUNDLE_WITH_ZP_BASE_PLAN_TYPES.includes(editType)) {
            categoryPlans = getBundleCategoryPlans(boughtPlans, planList, editType);
            categoryPlans.forEach(p => {
              if (p.type === planTypes.ZOOM_PHONE) {
                // don't need to match zp base plan by billing cycle
                addToCartByPlanCode(planList, p.plan_code, p.cartInfo?.selected_number);
              } else {
                addToCartByCategoryAndBillingCycle(planList, p.type, p.category, p.billing_cycle, p.cartInfo.selected_number)
              }
            });
            if (editType === planTypes.ZONE_PRO_PLUS) {
              const zoomPhoneAddtionalPlans = boughtPlans.filter(item => (
                item.type === planTypes.ZOOM_PHONE$ADDITIONAL &&
                (item.sub_type === PBX_SUB_TYPES.TOLLFREE || item.sub_type === PBX_SUB_TYPES.PHONE_NUMBER) &&
                item.region === PBX_REGIONS.US_AND_CANADA
              ))
              zoomPhoneAddtionalPlans.forEach(p => addToCartByPlanCode(planList, p.plan_code, p.cartInfo?.selected_number));
            }
            return planList;
          }

          // for url query have initial preload planCode params
          let preloadPeriod = $query.preloadPeriod;
          if (preloadPeriod) {
            const currentEditOldPlan = _.find(boughtPlans, x => (x.plan_code === oldPlanCode || x.mapping_plan_code === oldPlanCode));
            if (currentEditOldPlan) {
              const isExistTargetPlan = plansof(planList)
                .type(currentEditOldPlan.type)
                .category(currentEditOldPlan.category)
                .cycle(preloadPeriod)
                .has();

              logger.info("init shoppingCart from oldPlan", currentEditOldPlan, preloadPeriod, isExistTargetPlan);

              preloadPeriod = isExistTargetPlan ? preloadPeriod : currentEditOldPlan.billing_cycle;
              addToCartByCategoryAndBillingCycle(planList, currentEditOldPlan.type, currentEditOldPlan.category, preloadPeriod, currentEditOldPlan.cartInfo.selected_number)
              return planList;
            }
          }

          const oldPlanCode = $query?.oldPlanCode;
          if(oldPlanCode) categoryPlans = categoryPlans.filter(x => (x.plan_code === oldPlanCode || x.mapping_plan_code === oldPlanCode));
          // for zoom phone, we need to edit the addons at the same time
          if(editType === planTypes.ZOOM_PHONE){
            // known issue
            // types.ZOOM_PHONE is not included (initiated from plans/ZOOM_PHONE module instead)
            // while selectedPlansMap0 knows nothing about this change
            categoryPlans = [...categoryPlans, ...plansof(boughtPlans).type(planTypes.ZOOM_PHONE$ZPI, planTypes.ZOOM_PHONE$ZPA).get()];
            categoryPlans.forEach(plan => {
                // FIXME for zoom phone, there are plans of same type && category && billing cycle, this is stupid
                // and can we merge this into the below generic logic ?
                if(planList.find(x => x.plan_code === plan.plan_code)) return addToCartByPlanCode(planList, plan.plan_code, plan.cartInfo?.selected_number);
                addToCartByCategoryAndBillingCycle(planList, plan.type, plan.category, plan.billing_cycle, plan.cartInfo.selected_number);
            });
            // ZOOM-731601 [FE] Support upsell zoom phone power pack and international calling for companysetup
            // init power pack or international add-on by from ---- start
            if (pageConfig.from && editType === planTypes.ZOOM_PHONE) {
              const pbxBillingCycle = getPbxBillingCycle(boughtPlans)
              const { category_codes = [], fromType } = planQueryParser(pageConfig.from);
              if (fromType === planTypes.ZOOM_PHONE) {
                const hasBasePlan = boughtPlans.find(item => item.type === planTypes.ZOOM_PHONE && item.sub_type === PBX_SUB_TYPES.BASE);
                category_codes.filter(item => hasBasePlan && (item !== PBX_CATEGORYS.ZVP)).forEach(code => {
                  const hasSelected = planList.find(item => item.category === code && item.cartInfo.selected_number > 0);
                  const targetType = planList.find(item => item.category === code)?.type;
                  if(!hasSelected && targetType) {
                    addToCartByCategoryAndBillingCycle(planList, targetType, code, pbxBillingCycle, 1);
                  }
                })
              }
            }
            // init power pack or international add-on by from ---- end
            return planList;
          } else if ([planTypes.CONCURRENCY_MEETING_BASIC, planTypes.CONCURRENT_MEETING_PLUS].includes(editType)) {
            // Because Concurrent Meeting Basic + Concurrent Meeting Plus share the same categotyCode,
            // so use addToCartByPlanCode instead of addToCartByCategoryAndBillingCycle to avoid confusion
            categoryPlans.forEach((x) => addToCartByPlanCode(planList, x.plan_code, x.cartInfo?.selected_number))
            return planList;
          }
          categoryPlans.forEach(plan => {
            addToCartByCategoryAndBillingCycle(planList, plan.type, plan.category, plan.billing_cycle, plan.cartInfo.selected_number)
          });
        }

        return planList;
    };
};

const filterPlanList4BoughtPlans = (boughtPlans = []) => {
    return (planList = []) => {
        // check ze/zs plan list should align base plan billing cycle
        if ([planTypes.EVENT_SAAS, planTypes.EVENT_SAAS_CORE].includes(editType)) {
            return filterEventPlansForAdd2Cart(planList, boughtPlans);
        }
        return planList;
    }
};

export function filterForMultipleRatePlans(boughtPlans) {
  return (planMapFlat = []) => {
    const editPlanType = pageConfig?.editConfig?.planType;
    let relatedPlans = [];
    const multipleEditPlanMaps = {
      [planTypes.TOLLFREE]: [planTypes.TOLLFREE, planTypes.TOLLFREE$DID],
      [planTypes.ZOOM_MEETING]: [planTypes.TOLLFREE],
      [planTypes.ZOOM_ROOMS]: [planTypes.TOLLFREE],
      [planTypes.ZOOM_PHONE]: [planTypes.ZOOM_PHONE, planTypes.ZOOM_PHONE$ZPI, planTypes.ZOOM_PHONE$ZPA],
      //for auto add
      [planTypes.LARGE_MEETING]: [planTypes.ZOOM_MEETING],
      [planTypes.WEBINAR]: [planTypes.ZOOM_MEETING],
      [planTypes.EVENT_SAAS]: [planTypes.ZOOM_MEETING],
      [planTypes.EVENT_SAAS_CORE]: [planTypes.ZOOM_MEETING],
    }
    if (multipleEditPlanMaps[editPlanType]) {
      relatedPlans = _.filter(boughtPlans, (p) => multipleEditPlanMaps[editPlanType].includes(p.type));
    }
    relatedPlans = _.uniq([...relatedPlans, ..._.filter(boughtPlans, (p) => {
      const planCodeList = [p?.plan_code, p?.mapping_plan_code].filter(Boolean);
      return _.includes(planCodeList, pageConfig?.oldPlanCode);
    })]);

    relatedPlans.filter((p) => p.ratePlans?.length > 1).forEach(relatedPlan => {
      const currentPlanMap = planMapFlat.find(p => p.plan_code === relatedPlan.plan_code && p.billing_cycle === relatedPlan.billing_cycle);
      const validPrice = relatedPlan.ratePlans?.find(rate => rate?.useForUpsell)?.price;
      if (validPrice && currentPlanMap) {
        currentPlanMap.price = validPrice;
        currentPlanMap.amount = validPrice;
        currentPlanMap.ratePlans = relatedPlan.ratePlans;
      }
      // remove other billing cycle or capacity plan
      const shouldRemoveFilter = (p) => {
        const defaultConfig = () => p.type === relatedPlan.type && relatedPlan.plan_code !== p.plan_code;
        const specialConfig = {
          [planTypes.ZOOM_ONE_BUNDLE]: () => isBizPlusContext || isProPlusContext ? false : defaultConfig(),
          [planTypes.ZOOM_PHONE]: () => false,
          //tollfree can't distinguish by plan_code, should add billing_cycle rule
          [planTypes.TOLLFREE]: () => p.type === relatedPlan.type && p.category === relatedPlan.category
            && (relatedPlan.plan_code !== p.plan_code || (relatedPlan.plan_code === p.plan_code && relatedPlan.billing_cycle !== p.billing_cycle)),
        };
        const matchedFun = specialConfig[p.type];
        return matchedFun ? matchedFun() : defaultConfig();
      };
      planMapFlat = filter(planMapFlat, (p) => {
        return !shouldRemoveFilter(p);
      });
    });

    //did set price
    relatedPlans.filter((p) => p.tollfree_apac_ratePlans?.length > 1).forEach(relatedPlan => {
      const currentPlanMap = planMapFlat.find(p => p.plan_code === relatedPlan.plan_code && p.billing_cycle === relatedPlan.billing_cycle);
      const validPrice = relatedPlan.tollfree_apac_ratePlans.find(rate => rate?.useForUpsell)?.price;
      if (validPrice && currentPlanMap) {
        currentPlanMap.price = validPrice;
        currentPlanMap.amount = validPrice;
        currentPlanMap.ratePlans = relatedPlan.ratePlans;
      }
    });

    return planMapFlat;
  };
};

const initShoppingCart = async (state) => {
    const { persist } = state;
    const isNeedCallPbx = pageConfig?.editConfig?.planType === planTypes.ZOOM_PHONE; // TODO bundle & bizplus
    let oldPlanCode = pageConfig?.oldPlanCode;
    const { planMap, subscriptions, boughtPlans, freeTrialPlans, allPlanMap } = await buildAccountBaseService({isNeedCallPbx, isNeedCheckC25Plan: true, currentEditPlanCode: oldPlanCode, isCheckFromCampaign: isFromCampaignLink()});
    if($context.is.delta){
      const configData = get(window, 'newBillingConfig.preloadCartInfo.configData', {});
      const { plan = 'pro' } = configData;
      const planType = getPlanTypeByCategory(plan);
      const planCode = plansof(boughtPlans).type(planType).get(0).plan_code;
      if(!planCode) {
        offerNotEligible();
        return {};
      };
      // for generateCartId=addQty(delta) scenario
      // oldPlanCode is dependent on the user's current subscriptions
      // need to resolve oldPlanCode from boughtPlans
      // for generateCartId=addQty scenario, populate pageConfig with oldPlanCode
      pageConfig.oldPlanCode = pageConfig.editConfig.oldPlanCode = oldPlanCode = planCode;
    }
    const currentEditPlan = _.find(boughtPlans, (plan) => plan.plan_code === oldPlanCode) || {};
    const isCapacityPlan = _.includes(configCapacityTypes,currentEditPlan.type)
    // from pending and with cancellation coupon campaign case
    const fromCancelCampaignWithPendingCase = isFromCancelCampaignWithPendingCase(boughtPlans, oldPlanCode);

    const { result : capacityList } = isCapacityPlan ? await capacityConfig({
      flowType: flowTypes.edit,
      planKey: currentEditPlan.type,
      cancelCampaign: fromCancelCampaignWithPendingCase,
    }): {};
    let assignResult = {}
    try {
        if (isBizPlusContext || isProPlusContext || isEduSchCmpPlusContext) {
            const plans = plansof(boughtPlans).type(planTypes.ZOOM_ONE_BUNDLE, planTypes.ZONE_PRO_PLUS, planTypes.ZONE_EDU_PLUS).get();
            const codes = plans.map(p => p.plan_code);
            assignResult = await getAssignLicenseResult(currentEditPlan, codes);
        } else {
            assignResult = await getAssignLicenseResult(currentEditPlan);
        }
    } catch (error) {
        logger.error(error)
    }
    const loader = new PageLoader(planMap);
    loader.decorate('filterDisabledPlansWithSubscription', filterDisabledPlansWithSubscription(allPlanMap, subscriptions));
    loader.decorate('loadByPersist', loadSelectByPersist(persist));
    loader.decorate('loadDefaultPlansByPreloadCouponForEdit', loadDefaultPlansByPreloadCouponForEdit(boughtPlans));
    loader.decorate('loadDefaultPlansByPartnerReferralForEdit', loadDefaultPlansByPartnerReferralForEdit(boughtPlans));
    if (pageConfig.isFromAbandonEmail && !!pageConfig.preloadCartInfo) {
      try {
        await verifyAbandonCardForP2P();
        loader.decorate('loadDefaultPlansByCartId', loadDefaultPlansByCartId);
      } catch (error) {
        location.replace('/billing');
      }
    } else {
      loader.decorate('loadDefaultSelectByQuery', loadDefaultSelectByQuery(boughtPlans, subscriptions));
    }
    loader.decorate('filterPlanList4BoughtPlans', filterPlanList4BoughtPlans(boughtPlans));
    isCapacityPlan && loader.decorate('filterCapacity',filterCapacity(capacityList));
    loader.decorate('filterForMultipleRatePlans',filterForMultipleRatePlans(boughtPlans, subscriptions));
    const planList = await loader.dispatch();

    // FREE TRIAL - check error
    freeTrialIneligibleCheck()

    return {
        allPlanMap,
        boughtPlans,
        subscriptions,
        freeTrialPlans,
        planMapFlat: planList,
        assignResult,
    };
};

export const getPbxUpdateForm = getters => {
    const changedPlans = getters.selectedPlanListPayLoad ?? [];
    const changedPlancodes = changedPlans.map(x => x.planCode);
    const boughtPlans = getters.boughtPlans ?? [];

    const boughtPlansOfEditType = boughtPlans.filter(x => de$type(x.type) === editType);
    const deletedPlans = [];
    const allPbxPlan = computedPbxPlans(getters.planMapFlat).filter(p => p.category !== 'ZPD');

    boughtPlansOfEditType.forEach(x => {
        //if smb customer and planMapFlat not have this plan, means online not support, shouldn't to remove
        if (!allPbxPlan.some(p => p.plan_code === x.plan_code)) {
          return;
        }
        if (!changedPlancodes.includes(x.plan_code)) {
            deletedPlans.push({
                quantity: 0,
                planCode: x.plan_code,
            });
        }
    });

    // deletedPlans: edit & remove plan
    // but what about the online non-supported plans, they can be mis-canceled
    // should we record every delete action from user ? it is complcaited and not reliable
    // for now, backend has a filter for OPC non-supported plans
    const payload = [...changedPlans, ...deletedPlans];

    // for marketing coupon and support coupon, need add oldPlanCode params
    if (getters.fromCampaignLink || couponSourceTypeMap.isSupportCoupon(getters.couponState?.couponSourceType)) {
      _.forEach(payload, (p) => {
        // current planCode need in the current bought plans
        const isEditPlan = _.some(boughtPlans, (b) => b.plan_code === p.planCode);
        if (isEditPlan) {
          // current selected plan have discount
          const haveDiscount = _.get(getters.discountWithAmountMap?.discountPlans, [p?.planCode]);
          // in order to find oldPlanType with campaign
          haveDiscount && (p.oldPlanCode = p?.planCode);
        }
      });
    }

    return {
        planList: payload,
        actionType: UpdateTypes.UPDATE_PBX,
    };
}
function getEditPlanList(planType, oldPlanCode, getters) {
  const currentSelectedPlan = getters.getSelectedPlans.find(item => item.type === planType);
  const currentBoughtPlan = getters.boughtPlans.find(item => item.type === planType && item.plan_code === oldPlanCode);
  const isBasePlanUnsupportBillingCycle = isOnlineNotSupportPlan({
    planType: currentBoughtPlan?.type,
    billingCycle: currentBoughtPlan?.billing_cycle,
    category: currentBoughtPlan?.category
  });

  const quantity = currentSelectedPlan.cartInfo.selected_number
  if (isBasePlanUnsupportBillingCycle) {
    return [{
      oldPlanCode,
      oldPlanType: currentBoughtPlan?.plan_type,
      planCode: currentSelectedPlan.plan_code,
      planType: currentSelectedPlan.plan_type,
      quantity,
    }]
  } else {
    return [{
      quantity,
      planCode: currentSelectedPlan.plan_code,
      oldPlanCode: oldPlanCode,
  }]
  }
}
export const getSingleEditUpdateForm = getters => {
    const { planType, oldPlanCode } = pageConfig.editConfig;
    const currentSelectedPlan = getters.getSelectedPlans.find(item => item.type === planType);
    const currentBoughtPlan = getters.boughtPlans.find(item => item.type === planType && item.plan_code === oldPlanCode);
    let actionType = UpdateTypes.UPDATE_ADDON;
    if(planType === planTypes.ZOOM_MEETING || planType === planTypes.ZONE_BASIC_PLUS) {
        if(currentBoughtPlan?.category === currentSelectedPlan.category) {
            actionType = UpdateTypes.UPDATE_BASE
        } else if(currentSelectedPlan.category === 'biz') {
            actionType = UpdateTypes.PRO_TO_BIZ
        } else if(currentSelectedPlan.category === 'pro') {
            actionType = UpdateTypes.BIZ_TO_PRO
        } else if(currentSelectedPlan.category === 'zobasicp' || currentSelectedPlan.category === 'zobasicp') {
            actionType = UpdateTypes.DOWNGRADE_TO_ZONE_BASIC_PLUS
        }
    }
    if (planType === planTypes.ZONE_PRO_PLUS) {
      actionType = UpdateTypes.UPDATE_PRO_PLUS;
    }
    return {
        planList: getEditPlanList(planType, oldPlanCode, getters),
        actionType,
    };
}

export const getMultiEditUpdateForm = getters => {
  const actionType = UpdateTypes.UPDATE_ADDON;
  const { planType, oldPlanCode } = pageConfig.editConfig;
  const basePlanInfo = getBasePlanInfo(getters.getSelectedPlans)
  const planList = getEditPlanList(planType, oldPlanCode, getters);
  const boughtPlans = getters.boughtPlans;

  if (basePlanInfo.plans.length > 0) {
    const basePlan = basePlanInfo.plans[0]

    const unSupportBillingCycle = ONLINE_NOT_SUPPORT_BILLING_CYCLE.includes(basePlan.billing_cycle)
    const extraSubmitKeys = {}
    if (unSupportBillingCycle) {
      // SMB account need to submit planType field
      Object.assign(extraSubmitKeys, { planType: basePlan.plan_type, oldPlanType: basePlan.plan_type })
    }

    const boughtPlanBasePlan = _.find(boughtPlans, (p) => {
      return [basePlan?.plan_code, basePlan?.priceChangeMappingPlanCode].includes(p.plan_code);
    });

    const boughtBasePlanCode = boughtPlanBasePlan?.plan_code ?? basePlan?.plan_code;

    planList.unshift({
      quantity: basePlan?.cartInfo?.selected_number,
      planCode: basePlan?.plan_code,
      oldPlanCode: boughtBasePlanCode,
      ...extraSubmitKeys
    })
  }

  return { planList, actionType }
}

export const getBizPlusUpdateForm = (getters, supported = BIZ_PLUS_PLAN_CODES_ONLINE_SUPPORTED, types = [planTypes.ZOOM_ONE_BUNDLE], actionType = UpdateTypes.BIZ_PLUS) => {
    const _getPlanCodeMap = getPlanCodeMap(getters, types);
    const boughtPlansMap = _getPlanCodeMap(getters.boughtPlans.filter(p => supported.includes(p.plan_code)));
    const selectedPlansMap = _getPlanCodeMap(getters.getSelectedPlans);
    const unSupportBillingCycleMap = getUnsupportBillingCycleCategoryMap(boughtPlansMap, selectedPlansMap)
    let planList = [];
    const appliedSpecialSupportCoupon = couponSourceTypeMap?.isSupportCoupon(getters?.couponState?.couponSourceType);
    Object.keys(selectedPlansMap).forEach((planCode) => {
        const [quantity, category, planType] = selectedPlansMap[planCode];
        const [quantity1] = boughtPlansMap?.[planCode] ?? [];

        const extraSubmitKeys = {}
        if (unSupportBillingCycleMap[category]) {
          if (quantity1) {
            Object.assign(extraSubmitKeys, { planType, oldPlanType: planType })
          } else {
            // Only need planType field when add new plan
            Object.assign(extraSubmitKeys, { planType })
          }
        }

        // Just quantity changed
        const onlyForQuantityChange = quantity1 && quantity1 !== quantity;

        // Just quantity changed or special support coupon with change quantity flow
        if (onlyForQuantityChange || (appliedSpecialSupportCoupon && quantity1)) {
          planList.push({
            oldPlanCode: planCode,
            planCode,
            quantity,
            category,
            ...extraSubmitKeys
          });
        }

        if (!quantity1) {
        // Add new plan
        planList.push({
            planCode,
            quantity,
            category,
            ...extraSubmitKeys
        });
        }
    });

    Object.keys(boughtPlansMap).forEach((planCode) => {
        // eslint-disable-next-line no-unused-vars
        const [_, category, planType, billingCycle] = boughtPlansMap[planCode];
        const [quantity] = selectedPlansMap?.[planCode] ?? [];

        const unSupportBillingCycle = ONLINE_NOT_SUPPORT_BILLING_CYCLE.includes(billingCycle)
        const extraSubmitKeys = {}
        if (unSupportBillingCycle) {
          Object.assign(extraSubmitKeys, { planType, oldPlanType: planType })
        }

        if (!quantity) {
        // biz plus remove/switch region
        planList.push({
            oldPlanCode: planCode,
            planCode,
            quantity: 0,
            category,
            ...extraSubmitKeys
        });
        }
    });

    planList.forEach(p => {
      Reflect.deleteProperty(p, 'category');
    });

    const fromCampaignLink = getters.fromCampaignLink;
    const currentEditPlan = getters.currentEditPlan;
    const currentEditPlanCode = currentEditPlan?.plan_code;
    if (fromCampaignLink && currentEditPlanCode) {
      const quantity = selectedPlansMap[currentEditPlanCode][0];
      if (quantity > 0) {
        planList = [{
          oldPlanCode: currentEditPlanCode,
          planCode: currentEditPlanCode,
          quantity,
        }];
      }
      return { planList, actionType };
    }

    const isBulkLicenseAccount = getters.basicConfig?.isBulkLicenseAccount;
    if (isBulkLicenseAccount) {
      planList = planList.filter(p => p.quantity !== 0);
    }

    return { planList, actionType };
};

const getBizPlus2BizUpdateForm = (getters) => {
  const actionType = UpdateTypes.BIZ_PLUS_TO_BIZ;
  const bizPlan = getters.getSelectedPlans.find(p => p.type === planTypes.ZOOM_MEETING);
  const bundlePlans = getters.migratePlanState.planList.filter(p => getters.boughtPlans.find(plan => plan.plan_code === p.oldPlanCode));

  const planList = bundlePlans.map(p => {
    const extraKeys = {}
    if (p.oldPlanType) {
      Object.assign(extraKeys, { planType: bizPlan.plan_type, oldPlanType: p.oldPlanType })
    }
    return {
      ...p,
      quantity: bizPlan.cartInfo.selected_number,
      planCode: bizPlan.plan_code,
      ...extraKeys
    }
  });
  return { planList, actionType };
};
// edu school plus => edu school
const getEduPlus2EduSchoolUpdateForm = (getters) => {
  const actionType = UpdateTypes.EDU_SCH_CMP_PLUS_DOWNGRADE;
  const bizPlan = getters.getSelectedPlans.find(p => p.type === planTypes.ZOOM_MEETING);
  const bundlePlans = getters.migratePlanState.planList.filter(p => getters.boughtPlans.find(plan => plan.plan_code === p.oldPlanCode));

  const planList = bundlePlans.map(p => {
    const extraKeys = {}
    if (p.oldPlanType) {
      Object.assign(extraKeys, { planType: bizPlan.plan_type, oldPlanType: p.oldPlanType })
    }
    return {
      ...p,
      quantity: bizPlan.cartInfo.selected_number,
      planCode: bizPlan.plan_code,
      ...extraKeys
    }
  });
  return { planList, actionType };
}

export const getUpdateForm = getters => {
  let updateForm = {};
  if (editType === planTypes.ZOOM_PHONE) {
    updateForm = getPbxUpdateForm(getters);
  } else if (MULTI_UPDATE_PLAN_TYPES.includes(editType)) {
    updateForm = getMultiEditUpdateForm(getters);
  } else if (getters.migratePlanState.is.bundle2biz) {
    updateForm = getBizPlus2BizUpdateForm(getters);
  } else if (getters.migratePlanState.is.biz2bundle || getters.migratePlanState.is.pro2bundle) {
    updateForm = getMeeting2BizPlusUpdateForm(getters);
  } else if (getters.migratePlanState.is.esc2escp) {
    updateForm = getEdu2EduPlusUpdateForm(getters);
  } else if (getters.migratePlanState.is.escp2esc) {
    updateForm = getEduPlus2EduSchoolUpdateForm(getters);
  } else if (getters.migratePlanState.is.pro2prop) {
    updateForm = getPro2ProPlusUpdateForm(getters);
  } else if (getters.migratePlanState.is.prop2bundle) {
    updateForm = getProPlus2BizPlusUpdateForm(getters);
  } else if (
    getters.migratePlanState.is.biz2proplus ||
    getters.migratePlanState.is.bizplus2proplus
  ) {
    updateForm = getDowngradeToProPlusForm(getters);
  } else if (isBizPlusContext) {
    updateForm = getBizPlusUpdateForm(getters);
  } else if (isEduSchCmpPlusContext) {
    updateForm = getBizPlusUpdateForm(getters, EDU_SCH_CMP_PLUS_PLAN_CODES_SUPPORTED, [planTypes.ZONE_EDU_PLUS], UpdateTypes.EDU_SCH_CMP_PLUS_UPDATE);
  } else if (editType === planTypes.TOLLFREE) {
    updateForm = getTollFreeUpdateForm(getters);
  } else if (editType === planTypes.ZONE_PRO_PLUS) {
    updateForm = getProPlusEditForm(getters);
  } else {
    updateForm = getSingleEditUpdateForm(getters);
  }

  updateForm = checkAudioChange(getters, updateForm);

  setMultipleRatePlanFlag(updateForm);
  return updateForm;
};

const checkOutSubmit = async (submitParams) => {
    const getters = store.getters;
    const updateForm = getUpdateForm(getters);
    const couponData = getters.orderDataPayload.coupon;
    const partnerReferParams = getPartnershipParams();

    const extensionData = {
      ...updateForm.extensionUpdateData,
      ...partnerReferParams,
      scheduledEmailId: window.$cookie.get(ABANDON_CART_EMAIL_COOKIE_KEY),
    };
    // OBT-5767 for backend log
    if (
      editType === planTypes.WEBINAR
      && getters.currentEditPlan?.billing_cycle === BILLING_CYCLE.ONE_MONTH
      && !!pageConfig?.softWbnSub
    ) {
      extensionData.ref = 'webinar_schedule';
    }

    if (isInUnlockBizCountRetentionFlow()) {
      await reactiveBizPlanIfCancelled()
    // } else if (isInUnlockBizPlusCountRetentionFlow()) {
    //   await reactivateBizPlusIfCancelled()
    }

    return updatePlansCheckout(submitParams, updateForm.planList, updateForm.actionType, couponData, extensionData, updateForm.multiRatePlan);
};

const checkSMBBillingCycleChange = async () => {
  let editPlanType = pageConfig?.editConfig?.planType;
  const getters = store.getters;
  if (getters.migratePlanState.is.biz2bundle) {
    // biz to biz plus
    editPlanType = planTypes.ZOOM_ONE_BUNDLE;
  } else if (getters.migratePlanState.is.esc2escp) {
    // edu school to edu plus plus
    editPlanType = planTypes.ZONE_EDU_PLUS;
  } else if (getters.migratePlanState.is.bundle2biz || getters.migratePlanState.is.escp2esc) {
    // biz plus to biz, edu school plus to edu plus
    editPlanType = planTypes.ZOOM_MEETING;
  } else if (
    getters.migratePlanState.is.pro2prop ||
    getters.migratePlanState.is.biz2proplus ||
    getters.migratePlanState.is.bizplus2proplus
  ) {
    // pro to pro plus
    editPlanType = planTypes.ZONE_PRO_PLUS;
  } else if (getters.migratePlanState.is.upgrade) {
    return Promise.resolve();
  }
  const currentPlans = getters.getTypeGroupSelectedPlans[editPlanType] || [];

  if (currentPlans.length <= 0) {
    // No plan selected; Need a prompt
    return Promise.reject();
  }

  if (currentPlans.length > 1 && !isBizPlusContext) {
    return Promise.resolve();
  }

  const oldPlan = getters.currentEditPlan;
  const nextPlan = currentPlans[0] || {};

  if (ONLINE_NOT_SUPPORT_BILLING_CYCLE.includes(oldPlan?.billing_cycle) && !ONLINE_NOT_SUPPORT_BILLING_CYCLE.includes(nextPlan.billing_cycle)) {
    return MessageBox.confirm(translation('billing.error.smb_plan_billing_cycle_change_content'), translation('billing.error.smb_plan_billing_cycle_change_title'), {
      confirmButtonText: translation('billing.error.smb_plan_billing_cycle_change_yes'),
      cancelButtonText: translation('billing.error.smb_plan_billing_cycle_change_no'),
    }).then(() => {
        return Promise.resolve();
      },
    ).catch(() => {
      return Promise.reject();
    });
  }
  return Promise.resolve();
};

const resolveView = () => {
  return VIEWS.COMPOUND;
}

const preCheck = async () => {
  await checkBizPlusAddonLicensePromise();
  await checkZoneEduPlusAddonLicense()
  await preCheckForPbx();
  await checkCountriesRegionsOption();
  await preCheckPendingCouponForEdit();
  await checkOneMonthPlanDownSellForEdit();
  await checkPlanDownSellForEdit();
  await checkSMBBillingCycleChange();
  await showCouponTermsMessage(store.getters.tncMessage);
}

export default {
    [flowTypes.edit]: class extends Flow{
        view(){ return resolveView() }
        init(){ return initShoppingCart(...arguments) }
        beforeSubmit() { return preCheck() }
        submit(submitParams) { return checkOutSubmit(submitParams) }
    }
};

